namespace TabAurous.Inventory {
    export interface SKUStockItemForm {
        ProductCode: Serenity.StringEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: Serenity.LookupEditor;
        DesignId: Serenity.ServiceLookupEditor;
        BrandId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        ItemsDetails: SKUItemsEditor;
    }

    export class SKUStockItemForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SKUStockItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SKUStockItemForm.init)  {
                SKUStockItemForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = s.ServiceLookupEditor;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;
                var w6 = SKUItemsEditor;

                Q.initFormType(SKUStockItemForm, [
                    'ProductCode', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w1,
                    'DesignId', w3,
                    'BrandId', w1,
                    'SuperTypeId', w1,
                    'CollectionId', w1,
                    'Pieces', w4,
                    'Weight', w5,
                    'NetWeight', w5,
                    'ItemsDetails', w6
                ]);
            }
        }
    }
}
